export default "__VITE_ASSET__IsWT3_8e__"